import axios from 'axios';
import { getCookie } from '../utilities/helpers';

const timestamp = new Date().getTime();
const isCookie = getCookie('hfdebug');

const makeRequest = ({ url = '/', method = 'GET', headers, body, signal }) => {
  if (isCookie) {
    url = url + `${url.includes('?') ? '&' : '?'}t=${timestamp}`;
  }
  return axios({
    method,
    url,
    headers,
    data: body,
    signal,
  });
};

export default makeRequest
